module.exports = __webpack_public_path__ + "static/media/no-search.abc5ccb6.png";